import React from 'react'
import "./ImmortalDescription.css"

const ImmortalDescription = () => {
    return (
        <section class="container heritage-section">
            <p class="heritage-eyebrow">A CURATED VINYL EXPERIENCE</p>

            <h2 class="heritage-title">
                Rediscover the Golden Era of <span>Arabic & Oriental Music</span>
            </h2>

            <div class="heritage-divider"></div>

            <p class="heritage-text">
                Immerse yourself in the timeless beauty of legendary <strong>Arabic and Oriental </strong>
                music thoughtfully revived and presented on <strong>premium vinyl records </strong>for
                collectors and audiophiles alike.
            </p>

            <p class="heritage-text">
                Our curated selection features iconic titles, each meticulously restored
                from <strong>original master reels</strong> and <strong>remastered</strong> to meet the highest contemporary
                audio standards. The result:<strong> rich, authentic sound that honors the legacy
                of the music </strong>while delivering an exceptional listening experience.
            </p>

            <p class="heritage-footnote">
                Crafted in France by <strong>MPO</strong> , one of the world’s most respected vinyl manufacturers, each record is pressed on <strong>180-gram discs</strong> the gold standard for vinyl enthusiasts.
            </p>
        </section>

    )
}

export default ImmortalDescription
